function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var path = require('path');
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var Websitex = /*#__PURE__*/function (_ModTemplate) {
  function Websitex(app) {
    var _this;
    _classCallCheck(this, Websitex);
    _this = _callSuper(this, Websitex, [app]);
    _this.app = app;
    _this.name = 'Website';
    _this.slug = 'website';
    _this.description = 'Experimental Saito project website redesign.';
    _this.categories = 'Utilities Communications';
    _this["class"] = 'utility';
    _this.status = 'prod';
    _this.inhibit_block_sync_overlay = true;
    _this.header = null;
    _this.browserConnectedPeers = new Set();
    _this.publishBrowserNetworkStatus = null;
    _this.nodePeerSnapshot = [];
    _this.nodePeerSnapshotUpdatedAt = 0;
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(Websitex, _ModTemplate);
  return _createClass(Websitex, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this2 = this,
          _document$body;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(Websitex, "initialize", this, 3)([app]);
            case 1:
              if (app.BROWSER) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.buildNodePeerSnapshot(app);
            case 2:
              return _context2.a(2);
            case 3:
              if (!(typeof window === 'undefined')) {
                _context2.n = 4;
                break;
              }
              return _context2.a(2);
            case 4:
              this.publishBrowserNetworkStatus = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var requestedStage,
                  newBlock,
                  _app$wallet,
                  _app$wallet$getPublic,
                  _app$options,
                  _app$options2,
                  _app$network,
                  _app$network$getPeers,
                  _app$options3,
                  publicKey,
                  networkPeers,
                  peers,
                  configuredPeers,
                  stage,
                  _args = arguments,
                  _t,
                  _t2,
                  _t3,
                  _t4,
                  _t5;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      requestedStage = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'syncing';
                      newBlock = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                      _context.p = 1;
                      _context.n = 2;
                      return (_app$wallet = app.wallet) === null || _app$wallet === void 0 || (_app$wallet$getPublic = _app$wallet.getPublicKey) === null || _app$wallet$getPublic === void 0 ? void 0 : _app$wallet$getPublic.call(_app$wallet);
                    case 2:
                      _t3 = _context.v;
                      if (_t3) {
                        _context.n = 3;
                        break;
                      }
                      _t3 = (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.wallet) === null || _app$options === void 0 ? void 0 : _app$options.publicKey;
                    case 3:
                      _t2 = _t3;
                      if (_t2) {
                        _context.n = 4;
                        break;
                      }
                      _t2 = (_app$options2 = app.options) === null || _app$options2 === void 0 || (_app$options2 = _app$options2.wallet) === null || _app$options2 === void 0 ? void 0 : _app$options2.publickey;
                    case 4:
                      _t = _t2;
                      if (_t) {
                        _context.n = 5;
                        break;
                      }
                      _t = '';
                    case 5:
                      publicKey = _t;
                      _context.n = 6;
                      return (_app$network = app.network) === null || _app$network === void 0 || (_app$network$getPeers = _app$network.getPeers) === null || _app$network$getPeers === void 0 ? void 0 : _app$network$getPeers.call(_app$network);
                    case 6:
                      _t4 = _context.v;
                      if (_t4) {
                        _context.n = 7;
                        break;
                      }
                      _t4 = [];
                    case 7:
                      networkPeers = _t4;
                      peers = networkPeers.map(function (peer) {
                        return {
                          publicKey: peer.publicKey || '',
                          host: peer.host || '',
                          port: peer.port || 0,
                          protocol: peer.protocol || '',
                          synctype: peer.synctype || '',
                          status: peer.status || '',
                          connected: _this2.browserConnectedPeers.has(peer.publicKey)
                        };
                      });
                      configuredPeers = (Array.isArray((_app$options3 = app.options) === null || _app$options3 === void 0 ? void 0 : _app$options3.peers) ? app.options.peers : []).map(function (peer) {
                        return {
                          publicKey: peer.publicKey || peer.publickey || '',
                          host: peer.host || '',
                          port: peer.port || 0,
                          protocol: peer.protocol || '',
                          synctype: peer.synctype || '',
                          status: peer.status || '',
                          connected: _this2.browserConnectedPeers.has(peer.publicKey || peer.publickey)
                        };
                      });
                      stage = _this2.browserConnectedPeers.size ? 'online' : requestedStage;
                      window.dispatchEvent(new CustomEvent('saito-websitex-status', {
                        detail: {
                          stage: stage,
                          publicKey: publicKey,
                          peers: peers,
                          configuredPeers: configuredPeers,
                          newBlock: newBlock
                        }
                      }));
                      _context.n = 9;
                      break;
                    case 8:
                      _context.p = 8;
                      _t5 = _context.v;
                      console.warn('Websitex could not publish browser network status:', _t5);
                    case 9:
                      return _context.a(2);
                  }
                }, _callee, null, [[1, 8]]);
              }));
              window.saitoWebsitex = {
                requestStatus: function requestStatus() {
                  return _this2.publishBrowserNetworkStatus('syncing');
                }
              };
              app.connection.on('peer_connect', function (peerId, publicKey) {
                if (publicKey) {
                  _this2.browserConnectedPeers.add(publicKey);
                }
                _this2.publishBrowserNetworkStatus('online');
              });

              // Report handshakes directly; another module's async callback must not hold
              // the landing page's connection indicator in its loading state.
              app.connection.on('on_peer_handshake_complete', function (peerId, publicKey) {
                if (publicKey) {
                  _this2.browserConnectedPeers.add(publicKey);
                }
                _this2.publishBrowserNetworkStatus('online');
              });
              app.connection.on('peer_disconnect', function (peerId, publicKey) {
                if (publicKey) {
                  _this2.browserConnectedPeers["delete"](publicKey);
                }
                _this2.publishBrowserNetworkStatus('syncing');
              });
              if (!(this.browser_active && (_document$body = document.body) !== null && _document$body !== void 0 && _document$body.classList.contains('websitex'))) {
                _context2.n = 6;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context2.n = 5;
              return this.header.initialize(this.app);
            case 5:
              this.addComponent(this.header);
            case 6:
              window.setTimeout(function () {
                return _this2.publishBrowserNetworkStatus('syncing');
              }, 0);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _document$body2,
          _this3 = this;
        var saitoHeader, siteHeader, menuTrigger, desktopMenuProxy, sidebar, backdrop, syncMenuAccessibility, observeSidebar, toggleSaitoMenu;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _superPropGet(Websitex, "render", this, 3)([]);
            case 1:
              if (!(!this.app.BROWSER || !((_document$body2 = document.body) !== null && _document$body2 !== void 0 && _document$body2.classList.contains('websitex')))) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              saitoHeader = document.getElementById('saito-header');
              siteHeader = document.querySelector('[data-site-header]');
              menuTrigger = document.getElementById('saito-header-menu-toggle');
              desktopMenuProxy = document.querySelector('[data-saito-menu-toggle]');
              sidebar = document.querySelector('.saito-header-hamburger-contents');
              backdrop = document.querySelector('.saito-header-backdrop');
              if (!(!saitoHeader || !siteHeader || !menuTrigger || !sidebar || !backdrop)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              siteHeader.after(saitoHeader);
              menuTrigger.setAttribute('role', 'button');
              menuTrigger.setAttribute('tabindex', '0');
              menuTrigger.setAttribute('aria-label', 'Open Saito menu');
              menuTrigger.setAttribute('aria-controls', 'saito-sidebar');
              menuTrigger.setAttribute('aria-expanded', 'false');
              sidebar.id = 'saito-sidebar';
              syncMenuAccessibility = function syncMenuAccessibility() {
                var liveTrigger = document.getElementById('saito-header-menu-toggle');
                var liveSidebar = document.querySelector('.saito-header-hamburger-contents');
                if (!liveTrigger || !liveSidebar) {
                  return;
                }
                var isOpen = liveSidebar.classList.contains('show-menu');
                liveTrigger.setAttribute('aria-expanded', String(isOpen));
                liveTrigger.setAttribute('aria-label', isOpen ? 'Close Saito menu' : 'Open Saito menu');
                liveSidebar.id = 'saito-sidebar';
                if (desktopMenuProxy) {
                  desktopMenuProxy.setAttribute('aria-expanded', String(isOpen));
                  desktopMenuProxy.setAttribute('aria-label', isOpen ? 'Close Saito menu' : 'Open Saito menu');
                }
              };
              observeSidebar = function observeSidebar(liveSidebar) {
                if (!liveSidebar || liveSidebar.dataset.websitexObserved) {
                  return;
                }
                liveSidebar.dataset.websitexObserved = 'true';
                var menuObserver = new window.MutationObserver(syncMenuAccessibility);
                menuObserver.observe(liveSidebar, {
                  attributes: true,
                  attributeFilter: ['class']
                });
              };
              toggleSaitoMenu = function toggleSaitoMenu() {
                var _this3$header, _this3$header2;
                // Saito can replace its header while the page is running, so never retain references
                // to the drawer between proxy clicks.
                var liveSidebar = document.querySelector('.saito-header-hamburger-contents');
                var liveBackdrop = document.querySelector('.saito-header-backdrop');
                if (!liveSidebar || !liveBackdrop) {
                  return;
                }
                observeSidebar(liveSidebar);
                var shouldOpen = !liveSidebar.classList.contains('show-menu');

                // Set one explicit state. Forwarding a synthetic click and then checking fallbacks made
                // the handoff timing-dependent when the live header was re-rendering.
                if (shouldOpen && (_this3$header = _this3.header) !== null && _this3$header !== void 0 && _this3$header.openMenu) {
                  _this3.header.openMenu();
                } else if (!shouldOpen && (_this3$header2 = _this3.header) !== null && _this3$header2 !== void 0 && _this3$header2.hideMenu) {
                  _this3.header.hideMenu();
                } else {
                  liveSidebar.classList.toggle('show-menu', shouldOpen);
                  liveSidebar.classList.remove('show-wallet');
                  liveBackdrop.classList.toggle('menu-visible', shouldOpen);
                }
                syncMenuAccessibility();
              };
              window.saitoWebsitex.toggleMenu = toggleSaitoMenu;
              if (!menuTrigger.dataset.websitexBound) {
                menuTrigger.dataset.websitexBound = 'true';
                observeSidebar(sidebar);
                menuTrigger.addEventListener('keydown', function (event) {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    menuTrigger.click();
                  }
                });
              }
              syncMenuAccessibility();
              document.body.classList.add('saito-shell-ready');
              window.dispatchEvent(new CustomEvent('saito-websitex-shell-ready'));
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "respondTo",
    value: function respondTo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (type === 'saito-header') {
        return [{
          text: 'Docs',
          icon: 'fas fa-book-open',
          rank: 90,
          type: 'navigation',
          callback: function callback() {
            return window.open('https://wiki.saito.io/', '_blank', 'noopener');
          }
        }];
      }
      return _superPropGet(Websitex, "respondTo", this, 3)([type, obj]);
    }
  }, {
    key: "onPeerHandshakeComplete",
    value: function () {
      var _onPeerHandshakeComplete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, peer) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(!app.BROWSER || !this.publishBrowserNetworkStatus)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (peer !== null && peer !== void 0 && peer.publicKey) {
                this.browserConnectedPeers.add(peer.publicKey);
              }
              _context4.n = 2;
              return this.publishBrowserNetworkStatus('online');
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onPeerHandshakeComplete(_x2, _x3) {
        return _onPeerHandshakeComplete.apply(this, arguments);
      }
      return onPeerHandshakeComplete;
    }()
  }, {
    key: "buildNodePeerSnapshot",
    value: function () {
      var _buildNodePeerSnapshot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var app,
          _app$core,
          _app$core$getPeers,
          _app$wallet2,
          _app$wallet2$getPubli,
          networkPeers,
          ownPublicKey,
          _args5 = arguments,
          _t6,
          _t7,
          _t8;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              app = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : this.app;
              _context5.p = 1;
              _context5.n = 2;
              return (_app$core = app.core) === null || _app$core === void 0 || (_app$core = _app$core.network) === null || _app$core === void 0 || (_app$core$getPeers = _app$core.getPeers) === null || _app$core$getPeers === void 0 ? void 0 : _app$core$getPeers.call(_app$core);
            case 2:
              _t6 = _context5.v;
              if (_t6) {
                _context5.n = 3;
                break;
              }
              _t6 = [];
            case 3:
              networkPeers = _t6;
              _context5.n = 4;
              return (_app$wallet2 = app.wallet) === null || _app$wallet2 === void 0 || (_app$wallet2$getPubli = _app$wallet2.getPublicKey) === null || _app$wallet2$getPubli === void 0 ? void 0 : _app$wallet2$getPubli.call(_app$wallet2);
            case 4:
              _t7 = _context5.v;
              if (_t7) {
                _context5.n = 5;
                break;
              }
              _t7 = '';
            case 5:
              ownPublicKey = _t7;
              this.nodePeerSnapshot = networkPeers.filter(function (peer) {
                return !ownPublicKey || peer.publicKey !== ownPublicKey;
              }).map(function (peer) {
                var _peer$id, _peer$id$toString;
                return {
                  id: ((_peer$id = peer.id) === null || _peer$id === void 0 || (_peer$id$toString = _peer$id.toString) === null || _peer$id$toString === void 0 ? void 0 : _peer$id$toString.call(_peer$id)) || '',
                  publicKey: peer.publicKey || '',
                  host: peer.host || '',
                  port: peer.port || 0,
                  protocol: peer.protocol || '',
                  synctype: peer.synctype || '',
                  status: peer.status || '',
                  connected: true
                };
              });
              this.nodePeerSnapshotUpdatedAt = Date.now();
              _context5.n = 7;
              break;
            case 6:
              _context5.p = 6;
              _t8 = _context5.v;
              console.warn('Websitex could not update the node peer snapshot:', _t8);
            case 7:
              return _context5.a(2, this.nodePeerSnapshot);
          }
        }, _callee5, this, [[1, 6]]);
      }));
      function buildNodePeerSnapshot() {
        return _buildNodePeerSnapshot.apply(this, arguments);
      }
      return buildNodePeerSnapshot;
    }()
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(blk, lc) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(this.app.BROWSER && this.publishBrowserNetworkStatus)) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return this.publishBrowserNetworkStatus('online', true);
            case 1:
              _context6.n = 3;
              break;
            case 2:
              if (this.app.BROWSER) {
                _context6.n = 3;
                break;
              }
              _context6.n = 3;
              return this.buildNodePeerSnapshot(this.app);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function onNewBlock(_x4, _x5) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var _this4 = this;
      var alternative_slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var uri = alternative_slug || "/".concat(encodeURI(this.returnSlug()));
      var webdir = path.join(__dirname, 'web');
      var routeUri = uri === '/' ? '' : uri.replace(/\/$/, '');
      var trafficAnimation = path.join(__dirname, '../website/web/img/saito_bottom.svg');
      expressapp.get("".concat(routeUri, "/useful-traffic-animation.svg"), function (req, res) {
        res.sendFile(trafficAnimation);
      });
      expressapp.get("".concat(routeUri, "/network-status"), /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(req, res) {
          var _app$server, _app$options4, _app$wallet3, _app$wallet3$getPubli, endpoint, publicKey, peers, _t9, _t0, _t1, _t10;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.p = _context7.n) {
              case 0:
                res.setHeader('Cache-Control', 'no-store');
                _context7.p = 1;
                endpoint = ((_app$server = app.server) === null || _app$server === void 0 || (_app$server = _app$server.server) === null || _app$server === void 0 ? void 0 : _app$server.endpoint) || ((_app$options4 = app.options) === null || _app$options4 === void 0 || (_app$options4 = _app$options4.server) === null || _app$options4 === void 0 ? void 0 : _app$options4.endpoint) || {};
                _context7.n = 2;
                return (_app$wallet3 = app.wallet) === null || _app$wallet3 === void 0 || (_app$wallet3$getPubli = _app$wallet3.getPublicKey) === null || _app$wallet3$getPubli === void 0 ? void 0 : _app$wallet3$getPubli.call(_app$wallet3);
              case 2:
                _t0 = _context7.v;
                if (_t0) {
                  _context7.n = 3;
                  break;
                }
                _t0 = endpoint.publicKey;
              case 3:
                _t9 = _t0;
                if (_t9) {
                  _context7.n = 4;
                  break;
                }
                _t9 = '';
              case 4:
                publicKey = _t9;
                if (!_this4.nodePeerSnapshotUpdatedAt) {
                  _context7.n = 5;
                  break;
                }
                _t1 = _this4.nodePeerSnapshot;
                _context7.n = 7;
                break;
              case 5:
                _context7.n = 6;
                return _this4.buildNodePeerSnapshot(app);
              case 6:
                _t1 = _context7.v;
              case 7:
                peers = _t1;
                res.json({
                  publicKey: publicKey,
                  endpoint: {
                    host: endpoint.host || '',
                    port: endpoint.port || 0,
                    protocol: endpoint.protocol || '',
                    publicKey: endpoint.publicKey || publicKey
                  },
                  peers: peers,
                  updatedAt: _this4.nodePeerSnapshotUpdatedAt
                });
                _context7.n = 9;
                break;
              case 8:
                _context7.p = 8;
                _t10 = _context7.v;
                res.status(503).json({
                  error: 'Network status is temporarily unavailable.'
                });
              case 9:
                return _context7.a(2);
            }
          }, _callee7, null, [[1, 8]]);
        }));
        return function (_x6, _x7) {
          return _ref2.apply(this, arguments);
        };
      }());
      expressapp.use(uri, express["static"](webdir));
    }
  }]);
}(ModTemplate);
module.exports = Websitex;